import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { ActionsCollapser } from 'foundations-components/transitional/components/ActionsCollapser';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CollapsedButtonsGroupWrapper = styled.div.withConfig({
  displayName: "CollapsedButtonsGroup__CollapsedButtonsGroupWrapper"
})(["width:100%;button{& + button{margin-left:0 !important;margin-right:0 !important;border-left:none;border-start-start-radius:0;border-end-start-radius:0;}&:has(+ button){border-start-end-radius:0;border-end-end-radius:0;}}"]);
export const CollapsedButtonsGroup = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CollapsedButtonsGroupWrapper, {
      children: /*#__PURE__*/_jsx(ActionsCollapser, Object.assign({}, props, {
        children: children
      }))
    })
  );
};